<div class="hint">
  <ng-content />
</div>
